/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "9cd02ba7c84f976435f1ef54b04f5f3cd1a8a8f6";
